module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.10.0.0.box.652.786.730.120.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.10.0.0.box.652.786.730.120.q.100"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.10.1.0.box.320.1223.1395.1348.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.10.1.0.box.321.1223.1392.263.q.50"
    }
  }, [_vm._v("Why did I write a no-fat/low-fat cookbook? I wrote it for the same reason I wrote all my cookbooks: me! That's right. I wrote this book because I needed a healthy cookbook for me. Those who know me know that I started to pick up a few pounds (awe heck, not a few pounds, many pounds). In fact, the word "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tons ")]), _vm._v("comes to mind. Seriously, I got "), _c('i', [_vm._v("big! ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.1.box.321.1496.1394.644.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.1.0"
    }
  }), _vm._v("I have to credit a few people for helping me decide to embark on a healthy lifestyle and a serious change in my eating patterns. First, I owe the National Heart Attack Risk Study of St. Patrick's hospital kudos for starting me thinking about my weight and the increased risk of heart disease. This is a national study that has a branch at St. Patrick's hospital. They come in twice a year and take your blood pressure, weight, cholesterol, etc. They also bring with them certified staff nurses who talk to you about your potential risk of heart disease, changing your eating habits, and exercise. After a few visits, the seed was planted. This group doesn't use scare tactics; they provide information. That information concerned me enough to start thinking about my weight and lack of physical exercise.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.2.box.320.2149.1395.422.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.2.0"
    }
  }), _vm._v("Next on my list of people to thank is my doctor, Norman Davidson. Norman definitely got me thinking in his deadpan way. He told me something like this at my last physical: \"I am really surprised that you don't appear to show any signs of coronary heart disease.\" He said that he almost hoped I had shown some signs, so he could convince me to start losing weight. Boy, did that start me thinking. Basically, he was saying that it was just a matter of time before I would start to have problems. At least, that's what I thought he was saying. He just spoke so"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.11.0.0.box.313.314.1395.212.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.0.0"
    }
  }), _vm._v("\nsoftly and smiled and asked questions about my knowledge of food and why I had not put it to use. I mumbled something like I was a great teacher and great at telling others how to improve, but not really that good at following my own advice.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA10"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.11.0.0.box.313.314.1397.2171.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.11.0.1.box.314.535.1394.374.q.60"
    }
  }, [_vm._v("Anthony Robbins, a dynamic self-help instructor, helped me to realize that I have the power within myself to change my life. All I needed was the commitment! I listened to tape after tape, viewed a few of his videos, and one day, decided that I would change my direction and course of life. I did! That day, I decided that I would take the knowledge of food that I have been blessed with and use it to lose weight and keep it off.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.11.0.2.box.314.918.1394.319.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.2.0"
    }
  }), _vm._v("My wife, Debbie, was another person who played a major role in my decision to make the lifestyle change. I guess it was when she finally gave up trying to get me to lose weight, that I decided I had to make a significant change. I realized that if she finally gave up and resigned herself to the fact that I would not, could not, and did not lose weight; I never would. Then I knew it was time for me to make a change.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.11.0.3.box.314.1245.1395.478.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.3.0"
    }
  }), _vm._v("Let me say that none of the people listed here know the extent of their impact on my way of thinking! I think it is important to say what I've said because perhaps you will be able to relate to this story. I'm not writing this only as a book to use to lose weight, even though I know firsthand that a low or very low-fat diet combined with consistent light exercise will cause you to lose weight. I am really just putting down recipes that I know are good—at least to me—and I am encouraging anyone who needs good and tasty food that is low in fat to look at this book and perhaps use the recipes.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.11.0.4.box.313.1733.1397.535.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.4.0"
    }
  }), _vm._v("The time commitment required to change your eating habits is not that significant when you consider that doing so will allow you more time to live. I needed this book not to increase the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("quantity ")]), _vm._v("of my life, but rather to make a significant impact on the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("quality ")]), _vm._v("of my life. I can honestly say, after losing seventy-nine pounds and multiple inches, that the quality of my life has dramatically improved. I've lost weight before, but never before have I felt that I would succeed. I've always been giving up things on diets, but now I am not dieting! I am eating my way to weight loss. I eat around three thousand calories most days. I am eating snacks all day long. I eat until I am full.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.0.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.11.0.5.box.313.2277.1397.208.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.5.0"
    }
  }), _vm._v("I need to quickly tell you that diet alone won't do it. You will have to do some kind of exercise. I decided to walk. When I started walking at the start of this lifestyle change, I could not walk a half mile, and it took me more than thirty minutes to try. I now am walking two and a"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.12.0.0.box.314.339.1390.201.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0"
    }
  }), _vm._v("\nhalf miles in about 40 to 45 minutes, depending on the day and where I am walking. I make a little better time walking on an outdoor high school track than I do on an indoor track that takes 13 laps to make a mile.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.12.0.0.box.313.339.1395.2173.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.0.1.box.313.557.1394.1139.q.60"
    }
  }, [_vm._v("Exercise is not just a nice thing to do; it is vital and necessary. It helps to maintain your "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("lean ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("muscle ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mass. ")]), _vm._v("Why is lean muscle mass important? All my life I've been told that I had to raise my metabolism and that exercise would help do that. I always wondered just where my metabolism was located. Well guess what? Lean muscle mass is where your metabolism is—or at least where it is controlled. It is lean muscle that burns calories. If we diet and lose lean muscle mass in the process, we lower our metabolism. Now it begins to make sense. That's why I lost weight, but had less energy. As I dieted, my body needed less food because it was going to \"sleep!\" Add to that the fact that muscle weighs about five times what fat weighs. Another way of saying the same thing is that fat has five times the volume of muscle. No wonder I could lose so much weight. I was losing muscle. This time, I lost inches first. My clothes started to fit and actually started to get baggy. I have a belt that I was wearing when I started. It is kind of my marker. It is old, but I am still wearing it because it is an accurate marker of where I am going and where I have been. I am down ten inches on that belt in just over six months. I intend to wear that belt until I reach my goal, then I'm going to save it forever. It is my trophy. I want it to be a reminder of where I was and, more importantly, where I will not return. Like Tony Robbins says, I have changed who I am and how I view myself. That is the key!")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.0.2.box.314.1704.1394.808.q.60"
    }
  }, [_vm._v("Now I am using my knowledge of food and how the body metabolizes that food to ensure my success. If you need to share in that success, if you want to share in that success, or if you can simply use some delicious and easy-to-prepare no-fat/low-fat recipes, then this book is for you. But remember, I wrote this book for myself! That is not any different than any of my cookbooks. I always write for myself! I recommend that you make the recipes just like I make them the first time. There are wide margins on each page for a purpose. Make notes; write in the book: \"I like this recipe!\" or \"This is a great recipe, but I really don't like the mushrooms, so cut the mushrooms and add more carrots and onions,\" or \"Too hot, cut the red pepper,\" or \"This recipe needs more ...\" A cookbook is a guidebook. It is intended to give you ideas and guidance. I expect you to really like some of my recipes, and I expect that you won't like some. We all have different tastes, likes, and dislikes. I write for me. If your tastes are similar to mine, you'll like"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.13.0.0.box.314.315.1397.481.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0"
    }
  }), _vm._v("\nmost of my dishes. Where we differ, you may not care for a recipe. That's what makes life fun. We are all different! I don't view that as a weakness, but rather as a strength. Take my book and make it your book. Nothing would please me more than for you to tell me that you enjoy my book and that you have marked all over it and changed the things you wanted to change. I also like to hear from people on their individual likes and dislikes. It just might be that your way would taste better to me as well. Enjoy using this book, and I wish you a long, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cajun ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Healthy, ")]), _vm._v("and happy life.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.13.0.0.box.314.315.1397.864.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.13.0.1.box.314.859.1396.320.q.70"
    }
  }, [_vm._v("A word of caution: Be sure to see your doctor before you start on any exercise program or change in your eating style. We all have specific needs and wants. Your doctor has to be consulted for your health's sake. You should have a team approach if you want to be successful. You need to talk to your physician and work out a plan that will work for you. Your doctor can help you with specifics on an exercise and eating plan.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19c45ba4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0008.vue
// module id = 57
// module chunks = 0